<template>
    <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
    >
        <div class="max-w-inherit items-center flex box-border xxs:p-4 mlg:py-3 mlg:pl-6 mlg:pr-3 justify-between bg-[#252632E6] fixed xxs:bottom-5 mlg:bottom-5 left-[50%] rounded-lg z-[52] xxs:w-[90%] xxs:left-1/2 xxs:-translate-x-[50%] xxs:flex-col md:max-w-[560px] md:-translate-x-[25%] mlg:max-w-[960px] mlg:flex-row xl:w-[90%] mlg:-translate-x-[40%] xl:max-w-[1200px]">
            <p class="xxs:text-body-5 mlg:text-body-6 font-medium text-white">
                {{formattedTotalSelected}}
            </p>
            <div class="flex xxs:flex-col mlg:flex-row xxs:w-full mlg:w-auto">
                <Button v-if="SHOW_FEATURE" class="xxs:mt-4 mlg:mt-0 mlg:ml-2 flex xxs:items-center text-white" buttonType="outline-white" size="default" @click="emit('action', 'favorite')">
                    <img src="@/assets/icons/favorite-outline-white.svg" class="lg:block" alt="trash" />
                    <span class="ml-2">Favorite</span>
                </Button>
                <Button v-if="SHOW_FEATURE" class="xxs:mt-4 mlg:mt-0 mlg:ml-2 flex xxs:items-center text-white" buttonType="outline-white" size="default" @click="emit('action', 'share')">
                    <img src="@/assets/icons/share-white.svg" class="lg:block w-6" alt="trash" />
                    <span class="ml-2">Share</span>
                </Button>
                <Button v-if="SHOW_FEATURE" class="xxs:mt-4 mlg:mt-0 mlg:ml-2 flex xxs:items-center text-white" buttonType="outline-white" size="default" @click="emit('action','download')">
                    <img src="@/assets/icons/save-import-template.svg" class="lg:block " alt="activate profile" />
                    <span class="ml-2">Download</span>
                </Button>
                <Button class="xxs:mt-4 mlg:mt-0 mlg:ml-2 flex xxs:items-center text-white" buttonType="outline-white" size="default" @click="emit('action','move')">
                    <img src="@/assets/icons/save-import-template.svg" class="lg:block " alt="activate profile" />
                    <span class="ml-2">Move</span>
                </Button>
                <Button v-if="isAdmin" class="xxs:mt-4 mlg:mt-0 mlg:ml-2 flex xxs:items-center text-white" buttonType="outline-white" size="default" @click="emit('action','delete')">
                    <img src="@/assets/icons/delete-file.svg" class="lg:block" alt="delete" />
                    <span class="ml-2">Delete</span>
                </Button>
            </div>
        </div>
    </transition>
</template>

<script setup>
import {computed} from "vue";
import Button from "@/components/core/Button.vue";
import {storeToRefs} from "pinia";
import {useAuth} from "@/stores/AuthStore";

const SHOW_FEATURE = false;

const props = defineProps({
    selectedDocuments: {
        type: Object,
        required: true,
        default: () => {},
    },
    total: {
        type: Number,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
})

const {isAdmin} =  storeToRefs(useAuth());
const emit = defineEmits(['action']);

const formattedTotalSelected = computed(() => {
    let count;

    if(props.selectedDocuments.include[0] === '*') {
        count = props.total - props.selectedDocuments.exclude.length;
    } else {
        count = props.selectedDocuments.include.length;
    }

    const word = count === 1 ? 'document' : 'documents';
    return `${count} ${word} selected`;
})
</script>